import { useLocalStorage } from 'react-use';

import { type TrackConnectedSlackIntegrationParams } from '@air/analytics';

export const useSlackIntregrationProcessLocation = () => {
  const [slackIntegrationLocation, setSlackIntegrationLocation, removeSlackIntegrationLocation] = useLocalStorage<
    TrackConnectedSlackIntegrationParams['trackLocation']
  >('SLACK_INTEGRATION_PROCESS_LOCATION');

  return { slackIntegrationLocation, setSlackIntegrationLocation, removeSlackIntegrationLocation };
};
